// 版权页面
<template>
  <div class="main">
    <div class="center">
      <h1>营业执照</h1>
      <div class="copyImg"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="less">
h1 {
  opacity: 1;
  font-size: 35px;
  font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
  font-weight: 700;
  text-align: center;
  color: #4279db;
  line-height: 75px;
  margin: 100px 0;
}
.copyImg{
    width: 1100px;
    height: 900px;
    background: url('../assets/img/首页/建协工程咨询营业执照.jpg') 0 0 no-repeat;
    background-size: 100%;
    margin: 50px auto;
}
</style>
